import { Controller } from "@hotwired/stimulus"

/**
 * ImageFieldController - muestra una vista previa de la imagen seleccionada o
 * existente de un campo de archivo y permite eliminarla.
 * Se conecta con data-controller="image-field".
 *
 * Targets: input (archivo), preview (img), remove (marca oculta),
 * removeButton (botón para quitar la foto, solo visible si hay foto).
 */
export default class extends Controller {
  static targets = ["input", "preview", "remove", "removeButton"]

  // Previsualiza el archivo recién seleccionado y cancela cualquier eliminación pendiente.
  preview() {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    this.#showPreview(URL.createObjectURL(file))
    this.#toggleRemoveButton(true)
    if (this.hasRemoveTarget) this.removeTarget.value = "0"
  }

  // Limpia el campo y marca el adjunto existente para eliminarlo al guardar.
  remove() {
    this.inputTarget.value = ""
    if (this.hasRemoveTarget) this.removeTarget.value = "1"
    this.#hidePreview()
    this.#toggleRemoveButton(false)
  }

  #showPreview(src) {
    if (!this.hasPreviewTarget) return
    this.previewTarget.src = src
    this.previewTarget.classList.remove("d-none")
  }

  #hidePreview() {
    if (!this.hasPreviewTarget) return
    this.previewTarget.removeAttribute("src")
    this.previewTarget.classList.add("d-none")
  }

  // El botón de quitar solo tiene sentido cuando hay una foto (ya adjunta o
  // recién seleccionada), así que se muestra u oculta según ese estado.
  #toggleRemoveButton(show) {
    if (!this.hasRemoveButtonTarget) return
    this.removeButtonTarget.classList.toggle("d-none", !show)
  }
}
